// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { toAbsoluteUrl } from "../../../../_metronic/helpers/AssetHelpers";
import Tooltip from "@mui/material/Tooltip";
import MDAvatar from "components/MDAvatar";
import tooltipIcon from "../../assets/images/icons/catering-icons/tooltip-icon.svg";
export const ToolTipUI = (tooltipText) => {
  return (
    <Tooltip
      key={"general"}
      title={<div style={{ textAlign: "left" }}>{tooltipText.tooltipText}</div>}
      placeholder="bottom"
    >
      <MDAvatar src={tooltipIcon} name={"general"} size="sm" sx={{ width: 15, height: 15 }} />
    </Tooltip>
  );
};
